import {useContext} from "react";
import {ReducerStateInterface} from "../interfaces/core/ReducerStateInterface";
import {GlobalContext} from "../GlobalReducer";
import {BasketItemInterface} from "../interfaces/partners/advcake/BasketItemInterface";
import {convertToYml} from "./Utils";
import {DataInterface} from "../interfaces/partners/advcake/DataInterface";
import {PageTypes} from "../interfaces/partners/advcake/PageTypes";



export default function useAdvCake() {
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);


    const dataPush = (pageType: PageTypes, data: any, externalBasketProducts?: any) => {
        let baseData: DataInterface = {
            pageType: pageType,
            user: {
                email: state.customer?.email_uid || '' // email в виде хеша или уникальный идентификатор, если не передается, данное поле можно оставить пустым
            }
        };

        if(data){
            baseData = {...baseData, ...data};
        }

        if(!([PageTypes.MAIN_PAGE].includes(pageType)) && state.basket.length) {
            let basketProducts: BasketItemInterface[] = [];
            state.basket.forEach((item) => {
                basketProducts.push({
                    id: parseInt(item.modelColorItem.uid),
                    name: item.modelColorItem.name,
                    price: item.modelColorItem.min_price.amount / 100,
                    quantity: item.quantity,
                    categoryId: convertToYml(item.modelColorItem.category_id),
                    categoryName: item.modelColorItem.category_name
                });
            })

            baseData.basketProducts = basketProducts;
        }

        if(externalBasketProducts){
            baseData.basketProducts = externalBasketProducts;
        }


        //@ts-ignore
        window.advcake_data = window.advcake_data || [];
        //@ts-ignore
        window.advcake_data.push(baseData);

    }

    return {
        dataPush
    };
}